import { render, staticRenderFns } from "./RecorderImage.vue?vue&type=template&id=46d32b7b&scoped=true"
import script from "./RecorderImage.vue?vue&type=script&lang=js"
export * from "./RecorderImage.vue?vue&type=script&lang=js"
import style0 from "./RecorderImage.vue?vue&type=style&index=0&id=46d32b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d32b7b",
  null
  
)

export default component.exports